import React, { Component, Fragment } from 'react';
import { Button, Form, Header, Icon, Loader, Message, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import { fetchAcademicYears, fetchAllAcademicYears } from '../../Lookups/util';
import NonCycleProgramForm from './NonCycleProgramForm';
import PaginationFront from '../../util/PaginationFront';

class NonCycleProgramList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            error: false,
            showForm: false,
            editingRowData: null,
            deletingRowId: null,
            saving: false,

            activePage: 1,
            postsPerPage: 20,

            academicYears: [],
            selectedAcademicYearId: null,
            filteredData: [],
        };

        this.fetchData = this.fetchData.bind(this);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
        this.onCloseForm = this.onCloseForm.bind(this);
    }

    componentDidMount() {
        this.setState({ loading: true });
        Promise.all([
            axios.get('/non-cycle-programs'),
            fetchAcademicYears()
        ])
            .then(([programsRes, academicYearsRes]) => {
                const sortedYears = academicYearsRes.data.sort((a, b) => b.startYear - a.startYear);
                this.setState({
                    data: programsRes.data,
                    academicYears: sortedYears,
                    selectedAcademicYearId: sortedYears.length > 0 ? sortedYears[0].id : null,
                    loading: false,
                    error: false
                }, this.applyFilters);
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    error: true
                });
            });
    }

    fetchData() {
        this.setState({ loading: true });
        axios.get('/non-cycle-programs')
            .then(res => {
                this.setState({
                    data: res.data,
                    loading: false,
                    error: false
                }, this.applyFilters);
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    error: true
                });
            });
    }

    applyFilters = () => {
        const {
            data,
            selectedAcademicYearId,
            academicYears
        } = this.state;
        if (!selectedAcademicYearId) {
            this.setState({ filteredData: data });
            return;
        }
        const year = academicYears.find(y => y.id === selectedAcademicYearId);
        if (!year) {
            this.setState({ filteredData: data });
            return;
        }
        const startYear = year.startYear;
        const octStartYear = new Date(startYear, 9, 1);
        const octNextYear = new Date(startYear + 1, 9, 1);
        const filtered = data.filter(program => {
            const dateFrom = program.dateFrom ? new Date(program.dateFrom) : null;
            const dateTo = program.dateTo ? new Date(program.dateTo) : null;
            return (
                dateFrom && dateTo &&
                dateFrom <= octNextYear &&
                dateTo >= octStartYear
            );
        });
        this.setState({ filteredData: filtered });
    };

    handleDelete = () => {
        this.setState({ saving: true });
        axios.delete(`/non-cycle-programs/${this.state.deletingRowId}`)
            .then(() => {
                toast(<FormattedMessage id="externalStudent.toast.nonCycleProgramDeleted"/>);
                this.setState({
                    deletingRowId: null,
                    saving: false
                });
                this.fetchData();
            })
            .catch(() => {
                this.setState({ saving: false });
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
            });
    };

    onCloseForm() {
        this.setState({
            showForm: false,
            editingRowData: null
        });
    }

    handlePaginationChange(e, { activePage }) {
        this.setState({ activePage });
    }

    formatDate(timestamp) {
        return timestamp ? moment(timestamp)
            .format('D. M. YYYY.') : '-';
    }

    render() {
        const {
            data,
            loading,
            error,
            showForm,
            editingRowData,
            deletingRowId,
            saving,
            activePage,
            postsPerPage,
            academicYears,
            selectedAcademicYearId,
            filteredData,
        } = this.state;

        const indexOfLast = activePage * postsPerPage;
        const indexOfFirst = indexOfLast - postsPerPage;
        const currentPosts = filteredData.slice(indexOfFirst, indexOfLast);

        const localStorageRole = localStorage.getItem('activeRole');
        // const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const isProfessor = localStorageRole.slice(0, 8) === 'Profesor';

        return (
            <div>
                <Header as="h1"><FormattedMessage id="externalStudent.nonCyclePrograms"/></Header>
                <Segment.Group raised>
                    <Segment raised>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <Header as="h3">
                                <FormattedMessage id="externalStudent.nonCyclePrograms"/>
                            </Header>
                            {isStudentService &&
                                <Button
                                    primary
                                    color="green"
                                    disabled={loading || showForm || !!deletingRowId || saving || error}
                                    floated="right"
                                    icon
                                    labelPosition="right"
                                    size="small"
                                    style={FiltersOnStyle}
                                    onClick={() => this.setState({
                                        showForm: true,
                                        editingRowData: null
                                    })}
                                >
                                    <Icon className="add"/>
                                    <FormattedMessage id="externalStudent.createNonCycleProgram"/>
                                </Button>
                            }
                        </div>
                    </Segment>

                    <Segment>
                        <Form>
                            <Form.Group>
                                <Form.Select
                                    width={4}
                                    fluid
                                    label={<FormattedMessage id="externalStudent.academicYear"/>}
                                    placeholder={<FormattedMessage id="externalStudent.selectAcademicYear"/>}
                                    clearable
                                    options={academicYears.map(y => ({
                                        key: y.id,
                                        text: y.name,
                                        value: y.id
                                    }))}
                                    value={selectedAcademicYearId}
                                    onChange={(e, { value }) =>
                                        this.setState({ selectedAcademicYearId: value || null }, this.applyFilters)
                                    }
                                />
                            </Form.Group>
                        </Form>
                    </Segment>

                    {showForm &&
                        <Segment secondary>
                            <NonCycleProgramForm
                                program={editingRowData}
                                onCloseForm={this.onCloseForm}
                                onRefreshData={this.fetchData}
                            />
                        </Segment>
                    }

                    <Segment>
                        {loading ? (
                            <div style={{
                                paddingTop: '100px',
                                paddingBottom: '100px'
                            }}>
                                <Loader active inline="centered"/>
                            </div>
                        ) : error ? (
                            <Segment textAlign="center">
                                <Button basic onClick={this.fetchData}>
                                    <FormattedMessage id="externalStudent.loadAgain"/>
                                </Button>
                            </Segment>
                        ) : (
                            <Fragment>
                                {isProfessor &&
                                    <Message>
                                        U tabeli su prikazani samo neciklični programi na kojima je profesor angažovan
                                        kao voditelj.
                                    </Message>
                                }
                                <Table celled>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell colSpan={1}>
                                                <FormattedMessage id="externalStudent.ordinalNumber"/>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>
                                                <FormattedMessage id="externalStudent.nonCycleProgram"/>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>
                                                <FormattedMessage id="externalStudent.nonCycleStudyProgramType"/>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={2}>
                                                <FormattedMessage id="externalStudent.programAttendanceType"/>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>
                                                <FormattedMessage id="externalStudent.dateFrom"/>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={3}>
                                                <FormattedMessage id="externalStudent.dateTo"/>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell colSpan={2}></Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {currentPosts.length > 0 ? currentPosts.map((program, index) => (
                                            <Table.Row key={program.id}>
                                                <Table.Cell colSpan={1} verticalAlign="middle">
                                                    {indexOfFirst + index + 1}.
                                                </Table.Cell>
                                                <Table.Cell colSpan={3} verticalAlign="middle">
                                                    {program.programName || '-'}
                                                </Table.Cell>
                                                <Table.Cell colSpan={3} verticalAlign="middle">
                                                    {program.nonCycleStudyProgramType ? program.nonCycleStudyProgramType.name : '-'}
                                                </Table.Cell>
                                                <Table.Cell colSpan={2} verticalAlign="middle">
                                                    {program.attendanceType ? program.attendanceType.name : '-'}
                                                </Table.Cell>
                                                <Table.Cell colSpan={3} verticalAlign="middle">
                                                    {this.formatDate(program.dateFrom)}
                                                </Table.Cell>
                                                <Table.Cell colSpan={3} verticalAlign="middle">
                                                    {this.formatDate(program.dateTo)}
                                                </Table.Cell>
                                                <Table.Cell colSpan={2} textAlign="center" verticalAlign="middle">
                                                    {deletingRowId === program.id ? (
                                                        <Fragment>
                                                            <Popup
                                                                content={<FormattedMessage
                                                                    id="externalStudent.delete"/>}
                                                                position="top center"
                                                                trigger={
                                                                    <Button
                                                                        circular icon size="tiny" color="blue"
                                                                        onClick={this.handleDelete}
                                                                        disabled={saving} loading={saving}
                                                                    >
                                                                        <Icon name="check"/>
                                                                    </Button>
                                                                }
                                                            />
                                                            <Popup
                                                                content={<FormattedMessage
                                                                    id="externalStudent.cancel"/>}
                                                                position="top center"
                                                                trigger={
                                                                    <Button
                                                                        basic circular icon size="tiny" color="blue"
                                                                        onClick={() => this.setState({ deletingRowId: null })}
                                                                        disabled={saving}
                                                                    >
                                                                        <Icon name="close"/>
                                                                    </Button>
                                                                }
                                                            />
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                            <Popup
                                                                content={<FormattedMessage id="common.details"/>}
                                                                position="top center"
                                                                trigger={
                                                                    <Button
                                                                        as={Link}
                                                                        to={{
                                                                            pathname: '/neciklicni-studij/programi/detalji',
                                                                            state: { program },
                                                                        }}
                                                                        onClick={() => localStorage.setItem('nonCycleProgramId', program.id)}
                                                                        basic circular icon size="tiny" color="blue"
                                                                    >
                                                                        <Icon name="list"/>
                                                                    </Button>
                                                                }
                                                            />
                                                            {isStudentService &&
                                                                <Popup
                                                                    content={<FormattedMessage
                                                                        id="externalStudent.deleteNonCycleProgram"/>}
                                                                    position="top center"
                                                                    trigger={
                                                                        <Button
                                                                            basic circular icon size="tiny" color="red"
                                                                            disabled={showForm || !!deletingRowId}
                                                                            onClick={() => this.setState({ deletingRowId: program.id })}
                                                                        >
                                                                            <Icon name="trash alternate"/>
                                                                        </Button>
                                                                    }
                                                                />
                                                            }
                                                        </Fragment>
                                                    )}
                                                </Table.Cell>
                                            </Table.Row>
                                        )) : (
                                            <Table.Row>
                                                <Table.Cell colSpan={15} textAlign="left">
                                                    <FormattedMessage id="common.noDataToDisplay"/>
                                                </Table.Cell>
                                            </Table.Row>
                                        )}
                                    </Table.Body>
                                </Table>
                            </Fragment>
                        )}
                        {currentPosts.length > 0 && !loading &&
                            <PaginationFront
                                postsPerPage={postsPerPage}
                                totalPosts={filteredData.length}
                                paginate={this.handlePaginationChange}
                                activePage={activePage}
                            />
                        }
                    </Segment>
                </Segment.Group>
                <ToastContainer position="top-right" hideProgressBar={true}/>
            </div>
        );
    }
}

export default NonCycleProgramList;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleProgram/NonCycleProgramList.js